import Vue from 'vue';

Vue.component( 'selector-articulos', () => import( '@com/selectores/selector-articulos.vue' ) );
Vue.component( 'selector-codigospostales', () => import( '@com/selectores/selector-codigospostales.vue' ) );
Vue.component( 'selector-localidades', () => import( '@com/selectores/selector-localidades.vue' ) );
Vue.component( 'selector-provincias', () => import( '@com/selectores/selector-provincias.vue' ) );
Vue.component( 'selector-transportes', () => import( '@com/selectores/selector-transportes.vue' ) );
Vue.component( 'selector-clientes', () => import( '@com/selectores/selector-clientes.vue' ) );

Vue.component( 'selector-articulos-titulos', () => import( '@com/selectores/selector-articulos-titulos.vue' ) );
Vue.component( 'selector-articulos-sectores', () => import( '@com/selectores/selector-articulos-sectores.vue' ) );
Vue.component( 'selector-articulos-lineas', () => import( '@com/selectores/selector-articulos-lineas.vue' ) );
Vue.component( 'selector-articulos-marcas', () => import( '@com/selectores/selector-articulos-marcas.vue' ) );
